import { render, staticRenderFns } from "./EditUsername.vue?vue&type=template&id=5fcdfac3"
import script from "./EditUsername.vue?vue&type=script&lang=js"
export * from "./EditUsername.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports